import {
  DadosClinicosFormModel,
  DadosIdentificacaoFormModel,
  DadosIndividuoFormModel,
  EnderecoResidenciaFormModel,
  NotificacaoAgravoFormModel,
} from './model-notificacaoAgravo'
import {
  DadosClinicosSinanModel,
  DadosIdentificacaoSinanModel,
  DadosIndividuoSinanModel,
  NotificacaoSinanModel,
} from './model-sinan'

const FILIACAO_SEM_INFORMACAO = 'Sem informação'
const NUMERO_SEM_NUMERO = 'SN'

export const convertNotificacaoSinanQueryToForm = (notificacao: NotificacaoSinanModel): NotificacaoAgravoFormModel => ({
  dadosIdentificacao: convertDadosIdentificacao(notificacao.dadosIdentificacao),
  dadosIndividuo: convertDadosIndividuo(notificacao.dadosIndividuo),
  dadosClinicos: convertDadosClinicos(notificacao.dadosClinicos),
})

const convertDadosIdentificacao = (dados: DadosIdentificacaoSinanModel): DadosIdentificacaoFormModel => ({
  dataNotificacao: dados.dataNotificacao ?? undefined,
  nome: dados.nome ?? undefined,
  nomeSocial: dados.nomeSocial ?? undefined,
  cns: dados.cns ?? undefined,
  dataNascimento: dados.dataNascimento ?? undefined,
  sexo: dados.sexo ?? undefined,
  estrangeiro: dados.estrangeiro ?? undefined,
  racaCor: dados.racaCor ?? undefined,
  isCidadaoAldeado: dados.viveAldeado ?? undefined,
  identidadeGenero: dados.identidadeGenero ?? undefined,
  orientacaoSexual: dados.orientacaoSexual ?? undefined,
  isMembroComunidadeTradicional: dados.membroPovoComunidadeTradicional ?? undefined,
  gestante: dados.gestante ?? undefined,
  ...convertCpf(dados),
  ...convertFiliacao(dados),
})

const convertCpf = (dados: DadosIdentificacaoSinanModel): Partial<DadosIdentificacaoFormModel> => {
  const stNaoPossuiCpf = !dados.cpf && dados.motivoAusenciaCpf != null

  return {
    cpf: dados.cpf ?? undefined,
    stNaoPossuiCpf,
    justificativaNaoPossuiCpf: stNaoPossuiCpf ? dados.motivoAusenciaCpf : undefined,
  }
}

const convertFiliacao = (dados: DadosIdentificacaoSinanModel): Partial<DadosIdentificacaoFormModel> => {
  const desconheceNomeMae = dados.nomeFiliacao1 === FILIACAO_SEM_INFORMACAO
  const desconheceNomePai = dados.nomeFiliacao2 === FILIACAO_SEM_INFORMACAO

  return {
    nomeMae: desconheceNomeMae ? undefined : dados.nomeFiliacao1 ?? undefined,
    desconheceNomeMae,
    nomePai: desconheceNomePai ? undefined : dados.nomeFiliacao2 ?? undefined,
    desconheceNomePai,
  }
}

const convertDadosIndividuo = (dados: DadosIndividuoSinanModel): DadosIndividuoFormModel => ({
  escolaridade: dados.escolaridade ?? undefined,
  isProfissionalSaude: dados.profissionalSaude ?? undefined,
  possuiDeficiencia: dados.pessoaDeficiente ?? undefined,
  tipoDeficiencia: dados.tipoDeficiencia ?? undefined,
  isPessoaSituacaoRua: dados.situacaoRua ?? undefined,
  isPessoaPrivadaLiberdade: dados.pessoaPrivadaLiberdade ?? undefined,
  telefone: dados.telefone ?? undefined,
  endereco: convertEndereco(dados),
})

const convertEndereco = (dados: DadosIndividuoSinanModel): EnderecoResidenciaFormModel => ({
  cep: dados.cep ?? undefined,
  numero: dados.numero === NUMERO_SEM_NUMERO ? undefined : dados.numero ?? undefined,
  semNumero: dados.numero === NUMERO_SEM_NUMERO,
  complemento: dados.complemento ?? undefined,
  zona: dados.zona ?? undefined,
})

const convertDadosClinicos = (dados: DadosClinicosSinanModel): DadosClinicosFormModel => ({
  sinaisSintomas: dados.sinaisSintomas ?? undefined,
  outrosSinaisSintomas: dados.outroSinalSintoma ?? undefined,
  dataInicioSintomas: dados.dataInicioSintomas ?? undefined,
  dataDiagnostico: dados.dataDiagnostico ?? undefined,
  dataAtendimento: dados.dataAtendimento ?? undefined,
  isDoencaRelacionadaTrabalho: dados.relacionadoTrabalho ?? undefined,
  isDoencaRelacionadaDesastre: dados.relacionadoDesastre ?? undefined,
})
